module.exports = __webpack_public_path__ + "img/login-header.20a5c30d.png";